import {
  Breadcrumb,
  Button,
  PageHeader,
  Table,
  Popconfirm,
  message,
} from "antd";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Page from "_components/Page";
import { employeeService } from "_services";
import PropTypes from "prop-types";
import { CloseOutlined } from "@ant-design/icons";

const List = ({ match }) => {
  const { path } = match;
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    getEmployees();
  }, []);

  const getEmployees = () => {
    setLoading(true);
    employeeService
      .getAll()
      .then((data) => {
        setItems(data.content);
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getActionButtons = () => {
    let buttons = [];
    buttons.push(
      <Link to={`${path}/add`} key="btn-add">
        <Button>Add</Button>
      </Link>
    );
    return buttons;
  };

  const handleDelete = (id) => {
    employeeService
      .delete(id)
      .then((x) => {
        message.success("Successfully deleted!");
        getEmployees();
      })
      .catch((error) => {
        setError(error);
      });
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text, record) => (
        <Link to={`/employee/${record.id}/summary`}>{record.name}</Link>
      ),
    },
    {
      title: "NIC",
      dataIndex: "nic",
      key: "nic",
      render: (text, record) => record.nic ?? "",
    },
    {
      title: "Total Booked Mins",
      dataIndex: "totalBookedMins",
      key: "totalBookedMins",
      render: (text, record) => record.totalBookedMins ?? "-",
    },
    {
      title: "Total Labour Cost",
      dataIndex: "totalLabourCost",
      key: "totalLabourCost",
      render: (text, record) => record.totalLabourCost ?? "-",
    },
    {
      title: "Action",
      key: "action",
      width: "5%",
      render: (text, record) => (
        <Popconfirm
          title="Are you sure to delete this employee?"
          onConfirm={() => {
            handleDelete(record.id);
          }}
        >
          <CloseOutlined />
        </Popconfirm>
      ),
    },
  ];

  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/dashboard">Dashboard</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/purchase-orders">Employee</Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        }
        extra={getActionButtons()}
      >
        <Page inner error={error}>
          <Table
            bordered
            loading={loading}
            rowKey="id"
            size="small"
            columns={columns}
            dataSource={items}
          />
        </Page>
      </PageHeader>
    </div>
  );
};

List.propTypes = {
  match: PropTypes.isRequired,
};

export default List;
